import { Component, inject, OnInit } from '@angular/core'
import { ThemeModeService } from '@mg-platform/core/core-util'
import { ReferralType, UserAccountState } from '@mg-platform/users/users-data-access'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Store } from '@ngxs/store'
import { Observable } from 'rxjs'

@UntilDestroy()
@Component({
  selector: 'mg-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
  standalone: false
})
export class AuthLayoutComponent implements OnInit {
  referralType$: Observable<ReferralType> = inject(Store).select(UserAccountState.referralType)
  referralType: ReferralType

  referralTypes = ReferralType

  isDarkMode = false

  constructor(public themeModeService: ThemeModeService) {}

  ngOnInit(): void {
    this.themeModeService.isDarkMode.pipe(untilDestroyed(this)).subscribe((res) => {
      this.isDarkMode = res
    })

    setTimeout(() => {
      this.referralType$.pipe(untilDestroyed(this)).subscribe((res) => {
        this.referralType = res
      })
    })
  }
}
